export const blankIndustryOption = {
  name: '---',
  list: []
}

//
// withState('subIndustry', 'setSubIndustry', ''),
// withState('subSubIndustry', 'setSubSubIndustry', ''),
//

export default function (state) {
  if (state.account.loginStatus === 'idle') {
    return {
      companyProps: {
        annualRevenue: 0,
        industry: 'Standard',
        subIndustry: null,
        subSubIndustry: null,
        employeeCount: 0,
        hasTippedEmployees: true
      },
      industryOptions: {
        companyIndustry: blankIndustryOption,
        companySubIndustry: blankIndustryOption,
        companySubSubIndustry: blankIndustryOption
      },
      corpName: '',
      userName: '',
      loading: state.account.userPreferencesLoading
    }
  }

  return {
    companyProps: state.account.company,
    industryOptions: {
      companyIndustry: {
        name: 'customlist_gd_mwgd_industry',
        list: [
          { name: 'Building Services' },
          { name: 'Hospitality' },
          { name: 'Hospitality & Transportation' },
          { name: 'Hotel Workers' },
          { name: 'Standard' }
        ]
      },
      companySubIndustry: {
        name: 'customrecord_gd_mwgd_subind',
        list: [
          { name: 'Fast Food' },
          { name: 'Non-Fast Food' }
        ]
      },
      companySubSubIndustry: {
        name: 'customrecord_gd_mwgd_subsubind',
        list: [
          { name: 'Food Service Employee' },
          { name: 'General Service Employee' },
          { name: 'Resort Service Employee' }
        ]
      }
    },
    corpName: state.account.company.displayName,
    userName: state.account.user.fullName || state.account.user.name,
    loading: state.account.userPreferencesLoading
  }
}
